import { GroupedDiffusionResponse } from '../../lib/types/models/affectedStaff/affected-staff'
import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendContract(id: number) {
  return restApiClient.url(constructApiUrl(API.affectedStaffs.sendContract.url, { id })).post()
}

export function sendContracts(input: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.sendContracts.url, null))
    .post<GroupedDiffusionResponse, IdsInput>(input)
}
